/* eslint-disable max-statements */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Container } from '@mui/system';
import SimpleBackdrop from '../../components/sharedComponents/backdropLoader/loader';
import InsuranceDetails from './insuranceDetails';
import { otpBypassToggle, productDetails, toggleLoader } from './Redux/actions';
import { logFirebaseEventFromWeb } from '../../utils/helper';

const Insurance = () => {
  const { productId } = useParams();
  const dispatch = useDispatch();
  const { loader, productDetailsInfo } = useSelector((state) => state.InsuranceReducer);
  const params = new URLSearchParams(window.location.search);
  const authToken = params.get('auth_token');
  const deviceId = params.get('device_id');
  const utmSource = params.get('utm_source');
  const utmCampaign = params.get('utm_campaign');
  const utmMedium = params.get('utm_medium');

  if (authToken) {
    window.localStorage.setItem('authToken', authToken);
  }
  if (deviceId) {
    window.localStorage.setItem('deviceId', deviceId);
  }
  if (productId) {
    window.localStorage.setItem('insuranceProductId', productId);
  }
  if (utmSource) {
    window.localStorage.setItem('insuranceUtmSource', utmSource);
  }
  if (utmMedium) {
    window.localStorage.setItem('insuranceUtmMedium', utmMedium);
  }
  if (utmCampaign) {
    window.localStorage.setItem('insuranceUtmCampaign', utmCampaign);
  }

  useEffect(() => {
    if (Object.keys(productDetailsInfo)?.length === 0) {
      logFirebaseEventFromWeb('insurance_landing_page_view', {
        productCode: productId,
      });
      dispatch(productDetails(productId));
      dispatch(otpBypassToggle());
    } else {
      dispatch(toggleLoader({ loader: false }));
    }
  }, []);

  if (loader) {
    return (
      <Container>
        <SimpleBackdrop open={true} />
      </Container>
    );
  }

  return <InsuranceDetails payNow={false} />;
};

export default Insurance;
